import React from "react";

const WaitPage = () => {
	return <p>{"2 sec"}</p>;
};

export default WaitPage;



// WEBPACK FOOTER //
// ./src/components/WaitPage.js